
export default function PassioneSection() {
  return (
    <section id="passione" className="py-16 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
            <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
              La Mia Passione
            </span>
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
          </div>
          <h2 className="font-playfair text-[32px] md:text-[52px] font-bold text-[#2d3e40] leading-[1.15]">
            L&apos;Edificio come<br />Organismo <em className="text-[#6b8e7f] not-italic">Vivente</em>
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left Text */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1">
            <p className="font-montserrat text-[14px] md:text-[16px] leading-[1.9] md:leading-[2] text-[#2d3e40]/75 mb-6 md:mb-8">
              La mia passione risiede nella sfida di rendere l&apos;edificio un organismo vivente. Ho partecipato a prestigiosi progetti di riqualificazione urbana, focalizzandomi sull&apos;uso di <strong className="text-[#2d3e40] font-semibold">materiali naturali</strong> e sull&apos;efficienza termica passiva.
            </p>
            <p className="font-montserrat text-[14px] md:text-[16px] leading-[1.9] md:leading-[2] text-[#2d3e40]/75 mb-6 md:mb-8">
              La mia architettura non è solo estetica, è un impegno verso l&apos;ambiente e il <strong className="text-[#6b8e7f] font-semibold">benessere umano</strong>, dove ogni dettaglio è pensato per respirare. Credo fermamente che il futuro dell&apos;architettura risieda nella capacità di creare spazi che nutrano sia il corpo che lo spirito.
            </p>
            <p className="font-montserrat text-[14px] md:text-[16px] leading-[1.9] md:leading-[2] text-[#2d3e40]/75">
              Ogni materiale viene scelto non solo per le sue proprietà strutturali, ma per la sua storia, la sua provenienza e il suo impatto sull&apos;ecosistema. La <strong className="text-[#6b8e7f] font-semibold">pietra locale</strong>, il <strong className="text-[#6b8e7f] font-semibold">legno certificato</strong>, la <strong className="text-[#6b8e7f] font-semibold">terra cruda</strong> — sono i protagonisti di un&apos;architettura che racconta il territorio.
            </p>

            {/* Values */}
            <div className="mt-8 md:mt-12 grid grid-cols-2 gap-4 md:gap-6">
              {[
                { icon: 'ri-heart-pulse-line', label: 'Benessere Umano' },
                { icon: 'ri-earth-line', label: 'Rispetto Ambientale' },
                { icon: 'ri-lightbulb-line', label: 'Innovazione Continua' },
                { icon: 'ri-hand-heart-line', label: 'Responsabilità Sociale' },
              ].map((val, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-[#6b8e7f]/10 flex items-center justify-center shrink-0">
                    <i className={`${val.icon} text-[#6b8e7f] text-base md:text-lg`}></i>
                  </div>
                  <span className="font-montserrat text-[12px] md:text-[13px] font-medium text-[#2d3e40]">{val.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2">
            <div className="relative">
              <div className="w-full h-[350px] sm:h-[450px] lg:h-[600px] rounded-2xl overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
                <img
                  src="https://public.readdy.ai/ai/img_res/4cb41b2a2bd3b23de26071bb16c61848.jpg"
                  alt="Interni architettura sostenibile"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating Badge */}
              <div className="absolute -left-3 md:-left-6 bottom-8 md:bottom-12 bg-[#6b8e7f] rounded-xl md:rounded-2xl p-4 md:p-6 shadow-[0_8px_32px_rgba(107,142,127,0.3)]">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center">
                    <i className="ri-award-line text-white text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <span className="block font-playfair text-[18px] md:text-[20px] font-bold text-white">30+</span>
                    <span className="block font-montserrat text-[10px] md:text-[11px] text-white/70 uppercase tracking-[1px]">Anni di Passione</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
